export const DATA_SELECTABLE_ITEM_ID = "data-selectable-item-id";
export const SNAP_EFFECT_CONTAINER_ID = "snap-effect-container-id";
export const SNAP_EFFECT_ID = "snap-effect-id";
export const SVG_NAMESPACE = "http://www.w3.org/2000/svg";
